import { useQuery } from '@tanstack/react-query'

import { useApiContext } from '../context/ApiContext'

export function useSingleProjectInvite(id: string) {
  const { apiClient } = useApiContext()

  return useQuery(['projectInvite', id], () => apiClient.getSingleProjectInvite(id))
}
